import React from 'react';
import InputForm from '../../../components/form/InputForm';
import Button from '../../../components/Button';
import { formRequiredRules } from '../../../lib/formRules';
import './AuthForm.scss';

const AuthForm = (props) => {
  const { form, authData, setData, onLogin } = props;
  const { email, password } = authData;

  return (
    <div className="auth-form">
      <InputForm
        form={form}
        label="이메일"
        rules={[formRequiredRules(true, '제목을 입력해주세요.', false)]}
        initialValue={email}
        maxLength={30}
        onPressEnter={() => onLogin()}
        onChange={(value) => setData({ name: 'email', value })}
        name="adminEmail"
      />

      <InputForm
        form={form}
        isTrim={false}
        type="password"
        label="비밀번호"
        rules={[formRequiredRules(true, '비밀번호를 입력해주세요.', false)]}
        initialValue={password}
        maxLength={30}
        onPressEnter={() => onLogin()}
        onChange={(value) => setData({ name: 'password', value })}
        name="adminPassword"
      />

      <Button isRadius={true} color="primary" text="로그인" onClick={onLogin} />
    </div>
  );
};

export default AuthForm;
